import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Testimonial } from '../models/testimonial.interface';
import { environment } from '../../environments/environment'; // Asegúrate de que la ruta hacia tu carpeta environments sea correcta

@Injectable({
  providedIn: 'root',
})
export class TestimonialService {
  private http = inject(HttpClient);
  
  // Ahora dinámicamente usará la URL de desarrollo o producción
  private apiUrl = `${environment.apiUrl}/testimonials`;

  getTestimonials(): Observable<Testimonial[]> {
    return this.http.get<Testimonial[]>(this.apiUrl);
  }

  createTestimonial(testimonial: Omit<Testimonial, 'id'>): Observable<Testimonial> {
    return this.http.post<Testimonial>(this.apiUrl, testimonial);
  }
}
